export const parseSavedDate = (value) => {
    if (!value) return null;
    // Backend timestamps without an offset are UTC.
    const normalized = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}[T ]/.test(value) && !/(Z|[+-]\d{2}:?\d{2})$/i.test(value)
        ? `${value.replace(' ', 'T')}Z`
        : value;
    const date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date;
};

const LastSavedStatus = ({ value, className }) => {
    const date = parseSavedDate(value);
    return (
        <p className={className} role="status">
            {date ? <>Ultimo salvataggio: <time dateTime={date.toISOString()}>{date.toLocaleString('it-IT', {
                day: '2-digit', month: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit', second: '2-digit',
            })}</time></> : 'Nessun salvataggio confermato'}
        </p>
    );
};

export default LastSavedStatus;
